import { SERVER_IMAGE_BASE_URL } from "@constants/Constants";
import {
  setPrimaryColor1Theme,
  setPrimaryColor2Theme,
  setPrimaryColor3Theme,
  setPrimaryColor4Theme,
  setPrimaryColor5Theme,
  setSecondaryColorTheme,
  setSecondaryTextColorTheme,
  setSecondaryTextColorThemeHeaderFooter,
  setCustomLoginTheme,
  setDefaultTheme,
} from "@utilities/themeUtil";

function getXmlHttpObject() {
  var xmlHttp: any = null;
  if (window.XMLHttpRequest) {
    try {
      xmlHttp = new XMLHttpRequest();
    } catch (e) {}
  }
  return xmlHttp;
}

function applyTheme() {
  setDefaultTheme();
  try {
    const request = getXmlHttpObject();
    request.open("GET", getBaseUrl() + "theme.json", false);
    if (request != null) {
      request.send(null);
      if (request.status === 200) {
        let data = JSON.parse(request.responseText);
        if (data != null) {
          setPrimaryColor1Theme(data?.primary_color_1);
          setPrimaryColor2Theme(data?.primary_color_2);
          setPrimaryColor3Theme(data?.primary_color_3);
          setPrimaryColor4Theme(data?.primary_color_4);
          setPrimaryColor5Theme(data?.primary_color_5);
          setSecondaryColorTheme(data?.seconday_color);
          setSecondaryTextColorTheme(data?.seconday_text_color);
          setSecondaryTextColorThemeHeaderFooter(
            data?.secondary_text_color_header_footer
          );
          setCustomLoginTheme(data?.custom_login);
        }
      }
    }
  } catch (e) {}
}

(() => {
  var serverImageBaseUrl = "/NS/";
  try {
    const request = getXmlHttpObject();
    request.open("GET", "./config/config.json", false);
    if (request != null) {
      request.send(null);
      if (request.status === 200) {
        let data = JSON.parse(request.responseText);
        if (data != null) {
          serverImageBaseUrl = data?.baseUrl + data?.port + data?.context;
        }
      }
    }
  } catch (e) {}
  if (serverImageBaseUrl == null || serverImageBaseUrl == undefined)
    serverImageBaseUrl = "/NS/";
  localStorage.setItem(SERVER_IMAGE_BASE_URL, serverImageBaseUrl);
})();

export function getBaseUrl() {
  return (
    localStorage.getItem(SERVER_IMAGE_BASE_URL) +
    "IBSStaticResources/Bo_Resources/branding/"
  );
}

const baseUrl = getBaseUrl();
applyTheme();

export const getDownloadableFileName = (filePrefix: String) => {
  // ShoppingCart_20251103_115958.pdf
  const timestamp = Date.now(); // Get current time in milliseconds
  const dateObject = new Date(timestamp); // Create a Date object from the timestamp
  const fullYear = dateObject.getFullYear(); // Get the full year from the Date object
  const month = (dateObject.getMonth() + 1 < 10) ? '0' + (dateObject.getMonth() + 1) : (dateObject.getMonth() + 1);
  const day = dateObject.getDate(); // Gets the day of the month (1-31)
  // Convert the number to a string and use padStart to ensure two digits
  const twoDigitDay = day.toString().padStart(2, '0');
  const hour = dateObject.getHours();
  const twoDigitHour = hour.toString().padStart(2, '0');
  const minute = dateObject.getMinutes();
  const twoDigitMinute = minute.toString().padStart(2, '0');
  const second = dateObject.getSeconds();
  const twoDigitSecond = second.toString().padStart(2, '0');
  const downloadableFileName = `${filePrefix}_${fullYear}${month}${twoDigitDay}_${twoDigitHour}${twoDigitMinute}${twoDigitSecond}`;
  
  return downloadableFileName;
}

export let logo = baseUrl + "logo_svg.svg";
export let splash = baseUrl + "splash.jpg";
export let mobileSplash = baseUrl + "splash.jpg";
export let pdfLogo = baseUrl + "logo_png.png";
